import { Inputs, ParametersEnum } from '../../../types';
import { getProjectConfigurationParameters } from './get-project-configuration-parameters';
import { doorTypeLabels, forWetRoomsGALabels, colourGALabels, parametersGALabels } from '../../../const';

const VALUES_SEPARATOR = ',';
const PARAMS_SEPARATOR = '/';

export const getGaSubmitDoorProjectElementVariant = (inputsData: Inputs) => {
  const projectConfigurationParameters = getProjectConfigurationParameters(inputsData);

  return projectConfigurationParameters
    .reduce((accumulator: string[], { key, value }) => {
      switch (key) {
        case ParametersEnum.doorType: {
          const values = value
            .split(VALUES_SEPARATOR)
            .map(item => doorTypeLabels[item as keyof typeof doorTypeLabels])
            .join(`${VALUES_SEPARATOR} `);
          return [...accumulator, `${parametersGALabels.doorType} - ${values}`];
        }
        case ParametersEnum.forWetRooms: {
          const values = forWetRoomsGALabels[value as keyof typeof forWetRoomsGALabels];
          return [...accumulator, `${parametersGALabels.forWetRooms} - ${values}`];
        }
        case ParametersEnum.colour: {
          const values = value
            .split(VALUES_SEPARATOR)
            .map(item => colourGALabels[item as keyof typeof colourGALabels])
            .join(`${VALUES_SEPARATOR} `);
          return [...accumulator, `${parametersGALabels.colour} - ${values}`];
        }
        default:
          return accumulator;
      }
    }, [])
    .join(` ${PARAMS_SEPARATOR} `);
};
